import { discountPercent, type SareeDTO } from '@neyara/shared';
import { Link } from 'react-router';
import { Price } from './price';
import { SareeImage } from './saree-image';
import { Seal } from './seal';

/** A saree with its details on a champagne swing tag, as on the board's hang tag. */
export function SareeCard({ saree, eager = false }: { saree: SareeDTO; eager?: boolean }) {
  const off = discountPercent(saree.price, saree.compareAtPrice);
  const soldOut = saree.stock <= 0;

  return (
    <article data-reveal className="group relative">
      <Link to={`/sarees/${saree.slug}`} className="block focus-visible:outline-offset-4">
        <div className="relative aspect-[3/4] overflow-hidden">
          <SareeImage
            image={saree.images[0]}
            name={saree.name}
            eager={eager}
            sizes="(min-width: 1024px) 25vw, 50vw"
            className={`size-full transition-transform duration-700 ease-(--ease-out-expo) group-hover:scale-[1.035] ${soldOut ? 'saturate-[.55]' : ''}`}
          />
        </div>

        <div className="relative -mt-9 mr-2 ml-1.5 tag-drop origin-[18px_0] transition-transform duration-500 ease-(--ease-out-expo) group-hover:-rotate-[1.6deg] sm:mr-8 sm:ml-4">
          {/* thread from the tag's eyelet up into the photo */}
          <span aria-hidden="true" className="absolute -top-6 left-[17px] h-7 w-px bg-gold" />
          <div className="tag-shape bg-champagne px-4 pt-6 pb-4">
            <span
              aria-hidden="true"
              className="absolute top-2.5 left-3 size-2.5 rounded-full bg-tissue ring-1 ring-champagne-deep ring-inset"
            />
            <h3
              className={`font-display text-[0.8rem] leading-snug font-medium tracking-[0.05em] [overflow-wrap:anywhere] text-charcoal uppercase sm:text-[0.9rem] sm:tracking-[0.1em]`}
            >
              {saree.name}
            </h3>
            {saree.category && (
              <p className="mt-0.5 font-script text-[1.05rem] leading-tight text-ink-soft italic">{saree.category.name}</p>
            )}
            <Price
              price={saree.price}
              compareAtPrice={saree.compareAtPrice}
              className="mt-1.5 text-[0.95rem] text-maroon"
            />
          </div>
          <div className="absolute -top-16 right-1 flex flex-col gap-1.5 sm:-top-5 sm:-right-6">
            {soldOut ? (
              <Seal tone="charcoal" size="sm">
                Sold out
              </Seal>
            ) : (
              off !== null && (
                <Seal tone="pink" size="sm">
                  {off}% off
                </Seal>
              )
            )}
          </div>
        </div>
      </Link>
    </article>
  );
}
